import React from 'react'
import Image from 'next/image'
import { CHALLAN_FALLBACK_IMG, UNKNOWN_CHALLAN, ChallanItem } from './constants'
import styles from './whatsappChallan.module.scss'

type ChallanCardProps = {
  index: number
  item: ChallanItem
  showImage?: boolean
}

export const ChallanCard = ({ index, item, showImage = false }: ChallanCardProps) => {
  const violationDetail = item?.violations?.details?.[0]
  const offence = violationDetail?.offence || UNKNOWN_CHALLAN
  const penalty = item?.amount?.total

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <span className={styles.index}>{index + 1}.</span>
        <span className={styles.title}>{offence}</span>
        <span className={styles.amount}>{penalty ? `₹${penalty}` : ''}</span>
      </div>

      {showImage && (
        <div className={styles.imageWrapper}>
          <Image src={CHALLAN_FALLBACK_IMG} alt="Challan snapshot" fill priority />
        </div>
      )}
    </div>
  )
}
